import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import styles from "./landing-feature-store-hub.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
import { StoreHubIntro } from "./components/hub-intro";
import { Head, renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { StoreHubList } from "./components/store-hub-list";
import { Cta } from "./components/cta";
import { HowStoresWork } from "./components/how-stores-work";
export function LandingFeatureStoreHub({ story , preview , generatedAt  }) {
    var ref;
    const { content  } = useStoryblokState({
        story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    const { intro , findStore , howStoresWork , cta  } = content;
    const introTitle = intro[0].title;
    const introBody = renderWithResolver(intro[0].body);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "cinch store | Buy a car in person",
                fallbackDescription: "Drop into a cinch store to buy a car, faff-free and in person. See, touch and test-drive your next car at your closest cinch store."
            }),
            /*#__PURE__*/ _jsxs("article", {
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.storeHubIntroWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoreHubIntro, {
                            title: introTitle,
                            body: introBody
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.sectionWrapper
                        },
                        isSlim: true,
                        backgroundColor: "#F2F5FF",
                        children: /*#__PURE__*/ _jsx(StoreHubList, {
                            findStoreList: findStore[0]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        className: {
                            container: styles.howStoresWorkWrapper
                        },
                        children: /*#__PURE__*/ _jsx(HowStoresWork, {
                            howStoresWork: howStoresWork
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        backgroundColor: "#ECF5F9",
                        children: /*#__PURE__*/ _jsx(Cta, {
                            cta: cta[0]
                        })
                    })
                ]
            })
        ]
    });
}
export default LandingFeatureStoreHub;
